﻿import { useState, useEffect } from 'react';
import { GetProducerIDsFromNPN } from '../../../api/regedint';
import { useQuery } from '@tanstack/react-query';
import { useUser } from '../../../context/UserContext';
import { MenuItem, FormControl, Select, FormHelperText, TextField } from '@mui/material';

export const STATIC_PRODUCER_ID = '';
export default function ProducerIDsDropdown({ ...props }) {
  const user = useUser();
  const [producerID, setProducerID] = useState('');

  const getProducerIDsFromNPN = useQuery({
    queryKey: ['GetProducerIDsFromNPN', user.npnID],
    queryFn: async () => await GetProducerIDsFromNPN({ NPN: user.npnID, Status: '', State: '' })(),
    enabled: user !== null && producerID === '',
  });

  // Handle success logic with useEffect
  useEffect(() => {
    if (getProducerIDsFromNPN.isSuccess && getProducerIDsFromNPN.data) {
      const data = getProducerIDsFromNPN.data;

      // this if logic is used only for illustration
      if (props.setInititalProducerID) {
        if (data.length === 0) {
          if (user.isHO === false) {
            props.setInititalProducerID(user.producerID.split(',')[0]);
          }
        } else if (data.length === 1) {
          props.setInititalProducerID(data[0]);
        }
      }

      if (user.isHO === false) setProducerID(props.defaultValue || user.producerID.split(',')[0]);

      if (data != null && props.setIsVisible !== undefined) props.setIsVisible(data.length > 1);
    }
  }, [getProducerIDsFromNPN.isSuccess, getProducerIDsFromNPN.data]);

  if (
    getProducerIDsFromNPN.isFetching ||
    getProducerIDsFromNPN.isPending ||
    getProducerIDsFromNPN.isIdle
  )
    return null;

  if (user.isHO === true || user.npnID === 'HO') {
    return (
      <FormControl fullWidth required>
        <TextField
          id="producerID-input-field"
          label="Producer ID"
          required
          error={props.error}
          helperText={props.helperText}
          value={producerID}
          onChange={(event) => {
            setProducerID(event.target.value);
            props.setProducerID(event.target.value);
          }}
          variant={props.variant}
        />
      </FormControl>
    );
  }

  if (getProducerIDsFromNPN.data != null && getProducerIDsFromNPN.data.length <= 1) return null;

  return (
    <FormControl
      id="getProducerIDsFromNPN-select"
      key="getProducerIDsFromNPN-select"
      disabled={
        getProducerIDsFromNPN.isFetching ||
        getProducerIDsFromNPN.isPending ||
        getProducerIDsFromNPN.isIdle
      }
      className="exit-swipe-left"
      style={props.formControlStyle ? props.formControlStyle : { padding: '0.75em 0' }}
    >
      <Select
        labelId="getProducerIDsFromNPN-simple-select-label"
        id="getProducerIDsFromNPN-simple-select"
        value={producerID}
        variant={props.variant}
        style={{ width: '100%', height: '40px', padding: '0 5px' }}
        onChange={(event) => {
          setProducerID(event.target.value);
          props.setProducerID(event.target.value);
        }}
        MenuProps={{
          MenuListProps: {
            sx: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 },
          },
        }}
      >
        {getProducerIDsFromNPN.data != null &&
          getProducerIDsFromNPN.data.map((pr, i) => (
            <MenuItem
              style={{ display: 'block', padding: '0.5em 1em' }}
              key={pr + '-' + i}
              value={pr}
            >
              {pr}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText>Producer IDs</FormHelperText>
    </FormControl>
  );
}
